import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';

const superagent = superagentPromise(_superagent, global.Promise);

let API_ROOT = 'https://api-staging.auditionmagic.com';
if (process.env.NODE_ENV === 'production') {
  // API_ROOT = 'https://api-staging.auditionmagic.com';
  API_ROOT = 'https://api.auditionmagic.com';
} else if (process.env.NODE_ENV === 'staging') {
  API_ROOT = 'https://api.auditionmagic.com';
} else {
  // API_ROOT = 'http://0.0.0.0:3000';
  API_ROOT = 'https://api.auditionmagic.com';
  // API_ROOT = 'https://api-staging.auditionmagic.com';
}

const encode = encodeURIComponent;
const responseBody = res => res.body;


let apiErrorHandler = error => {
  window.appsignal.sendError({
    description: `Pubreg Error on #{window.location.href}`,
    error: `Pubreg Error on #{window.location.href}`});
}

let authToken = null;
// let authToken = {"token":"zYXHWdMNNLn_jWsB1GAj","email":"brad@auditionmagic.com","id":17};
const tokenPlugin = req => {
  if (authToken) {
    req.set('authorization', `Token token="${authToken.token || authToken.authentication_token}", email="${authToken.email}"`);
    req.set('X-AM-Hostname', window.location.hostname);
  }
}


const requests = {
  del: url =>
    superagent.del(`${API_ROOT}${url}`).use(tokenPlugin).on('error', apiErrorHandler).then(responseBody),
  get: url =>
    superagent.get(`${API_ROOT}${url}`).use(tokenPlugin).on('error', apiErrorHandler).then(responseBody),
  put: (url, body) =>
    superagent.put(`${API_ROOT}${url}`, body).use(tokenPlugin).on('error', apiErrorHandler).then(responseBody),
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).accept('application/json').use(tokenPlugin).on('error', apiErrorHandler).then(responseBody),
};

const Project = {
  viaToken: access_token =>
    requests.get(`/pre_registration/projects/get_project_via_token?access_token=${access_token}`),
  createAudition: data =>
    requests.post('/pre_registration/artists/create_audition', data),
  auditionDates: data =>
    requests.get(`/api/audition_events?project_id=${data.project_id}&room_id=${data.room_id}&only_dates=true`),
  getRooms: data =>
    requests.get(`/api/audition_events/available_rooms?project_id=${data.id}`),
  getLocations: project_id =>
    requests.get(`/api/audition_events/available_locations?project_id=${project_id}`),
  auditionEvents: (data, date) =>
    requests.get(`/api/audition_events?project_id=${data.project_id}&room_id=${data.room_id}&date=${date}`),
  auditionEventById: id =>
    requests.get(`/api/audition_events/${id}`),
  reserve: data => 
    requests.put(`/api/audition_events/${data.eventId}/reserve`, { audition_ids: data.auditionId }),
  confirmReserve: data => 
    requests.put(`/api/audition_events/${data.eventId}/reserve?with_confirmation=true`, { audition_ids: data.auditionId }),
  getMedia: id =>
    requests.get(`/api/media/${id}`),
  mediaForArtist: (project_id, artist_id, roles) =>
    requests.get(`/checkin/media?project_id=${project_id}&artist_id=${artist_id}&roles=${roles}`),
  mediaForArtist: (project_id, artist_id) =>
    requests.get(`/checkin/media?project_id=${project_id}&artist_id=${artist_id}`),


  // V2
  projects: () =>
    requests.get(`/api/v2/projects`),
  getCheckinProj: (artist_id) =>
    requests.get(`/api/v2/projects?artist_id=${artist_id}&checkin_enabled=true`),
  getPubRegProj: (artist_id) =>
    requests.get(`/api/v2/projects?artist_id=${artist_id}&pre_registration=true`),
  projectById: id =>
    requests.get(`/api/v2/projects/${id}`),
  myProjects: token =>
    requests.get(`/api/v2/my/projects?token=${token}`),
  myProjectByid: (token, id) =>
    requests.get(`/api/v2/my/projects/${id}?token=${token}`),
  getRoles: (project_id) =>
    requests.get(`/api/v2/roles/available/${project_id}?per_page=100`),
  getRolesForArtist: (project_id, artist_id) =>
    requests.get(`/api/v2/roles/available/${project_id}?artist_id=${artist_id}`),
  // getRoles: (project_id) =>
  //   requests.get(`/api/v2/my/projects/${project_id}/roles/available`),
  // getRoles: (project_id, token) =>
  //   requests.get(`/api/v2/my/projects/${project_id}/roles/available?token=${token}`),
  requestSignedURL: (params) =>
    requests.post(`/api/auditions/signed_url`, { params })
  
}


// This can be Artist, Company, Agency info
// Returned object will be based on token owner
const My = {
  info: token =>
    requests.get(`/api/v2/my/info?token=${token}`), 
}


const Agency = {
  register: agency =>
    requests.post('/pre_registration/companies', agency),
  search: (search, country) =>
    requests.get(`/api/agencies?search=${search}`),
  agencyInfo: token =>
    requests.get(`/api/v2/agencies?token=${token}`),
  representationRequest: (token, status ) =>
    requests.get(`/api/v2/representation_requests?token=${token}&status=${status}`),
  representationArtist: (id, token) =>
    requests.get(`/api/v2/representation_requests/${id}?token=${token}`),
  representationApprove: (id, token) =>
    requests.put(`/api/v2/representation_requests/${id}/approve?token=${token}`),
  representationDeny: (id, token) =>
    requests.put(`/api/v2/representation_requests/${id}/deny?token=${token}`),
  companyDetails: (id) =>
    requests.get(`/api/v2/agencies/${id}`),
  updateTalentDetails: (id, artist) =>
    requests.put(`/api/v2/artists/${id}`, artist)
}

const Artist = {
  projects: id =>
    requests.get(`/checkin/projects?artist=${id}`),
  register: data =>
    requests.post('/checkin/artists', data),
  login: (username, password) =>
    requests.post('/checkin/artists/login', { username, password }),
  saveCurrentCheckin: data =>
    requests.post('/checkin/projects', { artist: data }),
  checkin: data =>
    requests.post('/checkin/projects', { artist: data, finalize: true }),
  search: artist =>
    requests.post('/checkin/artists/search', { artist }),
  projectDetails: id =>
    requests.get(`/checkin/projects/${id}`),
  updateDetails: (id, artist) =>
    requests.put(`/api/artists/${id}`, artist),
  updateProfile: (id, artist) =>
    requests.put(`/api/v2/artists/${id}`, artist),
  artistDetails: (id) =>
    requests.get(`/api/artist/${id}`),
  publicUpload: (id, avatar) =>
    requests.put(`/api/artists/${id}/public_upload`, { artist: avatar }),
  finalizeFiles: (mediumID) =>
    requests.get(`/api/artists/${mediumID}/finalize_files`)
}

const Client = {
  login: (email, password) =>
    requests.post('/users/sign_in', {user: {email, password} }),
  getUser: id =>
    requests.get(`/api/users/${id}`),
  getProjects: id =>
    // requests.get(`/api/projects?company_id=${id}`),
    requests.get(`/checkin/projects/client_projects?company_id=${id}`),
  getProjectById: id => 
    requests.get(`/api/projects/${id}`),
  getRegQuestions: (id) =>
    requests.get(`/checkin/questions?project_id=${id}`),
  getCheckinQuestions: (id) =>
    requests.get(`/checkin/questions?project_id=${id}&checkin=true`),
  updateSettings: (projectId, project) =>
    requests.put(`/api/projects/${projectId}`, project ),
  checkProjectArtist: (projectId, artistId) =>
    requests.get(`/checkin/projects/${projectId}?artist=${artistId}`),
  pullUser: (token) =>
    requests.get(`/api/v2/artists/pull_user?password_token=${token}`),
  requestPasswordChange: (email) =>
    requests.get(`/api/v2/artists/request_password_change?email=${encodeURIComponent(email)}`),
  changePassword: params =>
    requests.put(`/api/v2/artists/change_password`, params)


}

export default {
  Project,
  Agency,
  Artist,
  My,
  Client,
  API_ROOT,
  setToken: (_authToken) => { authToken = _authToken; }
};



// WEBPACK FOOTER //
// ./src/agent.js